import { translate } from "app/filters/i18nFilter";

export const deviceTitleMap = {
    AndroidTablet: "Android Tablet",
    AndroidPhone: "Android Phone",
    Combined: "Total",
    Total: "Total",
};

export const storeTotalTexts = {
    Combined: {
        get Google() {
            return translate("apps.engagement.mau.combined.devices.caption.android");
        },
        get Apple() {
            return translate("apps.engagement.mau.combined.devices.caption.ios");
        },
    },
    Total: {
        get Google() {
            return translate("apps.engagement.mau.combined.devices.caption.android");
        },
        get Apple() {
            return translate("apps.engagement.mau.combined.devices.caption.ios");
        },
    },
};
